import styled from 'styled-components';
import { Grid } from '@material-ui/core';

export const StyledLogoContainer = styled('div')({
  position: 'absolute',
  top: 53,
  left: 122,
  '@media(max-width: 768px)': {
    left: 24,
    top: 24,
    '>svg': {
      width: 100
    }
  }
});

export const StyledGridContainer = styled(Grid)({
  height: '100%',
  '@media(max-width: 768px)': {
    height: '90%'
  }
});

export const Header = styled('h1')({
  textAlign: 'center',
  fontWeight: 600,
  fontSize: 30,
  marginBottom: 30,
  color: '#000'
});

export const StyledFooter = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: '0 16px 60px'
});

export const StyledButtonContainr = styled('div')({
  display: 'flex',
  gap: 16,
  alignItems: 'center'
});

export const StyledText = styled('span')({
  color: '#000',
  fontSize: 16,
  fontWeight: 400
});

export const StyledDivider = styled('hr')({
  border: 'none',
  margin: '30px auto',
  width: '80%',
  height: 1,
  backgroundColor: '#eaeaea'
});
